export const CONTACT_FORM_INIT = 'CONTACT_FORM_INIT';
export const CONTACT_FORM_SUCCESS = 'CONTACT_FORM_SUCCESS';
export const CONTACT_FORM_FAIL = 'CONTACT_FORM_FAIL';

export const TOGGLE_SIDE_NAV = 'TOGGLE_SIDE_NAV';

